import {
  IconFile,
  IconFileTextSpark,
  IconLayoutGrid,
  IconTableExport,
  IconZoomScan,
} from '@tabler/icons-react'
import { TopLevelLinkProps } from '@shared/components/app-shell/main-menu/main-menu'
import { generatePath } from 'react-router-dom'
import { routes } from '@/routing/routes'

export const MAIN_MENU_LINKS: Array<TopLevelLinkProps> = [
  {
    label: 'Dashboard',
    href: routes.home.path,
    icon: <IconLayoutGrid />,
  },
  {
    label: 'Resources',
    href: routes.resources.path,
    icon: <IconZoomScan />,
  },
]

export const stationScopedMenuLinks = (stationRecordNumber: string): Array<TopLevelLinkProps> => [
  {
    label: 'Dashboard',
    href: routes.home.path,
    icon: <IconLayoutGrid />,
  },
  {
    label: 'Wool Data',
    href: generatePath(routes.woolData.path, { stationRecordNumber }),
    icon: <IconTableExport />,
  },
  {
    label: 'Wool Specifications',
    href: generatePath(routes.listSpeci.path, { stationRecordNumber }),
    icon: <IconZoomScan />,
  },
  {
    label: 'Offers',
    href: generatePath(routes.listOffers.path, { stationRecordNumber }),
    icon: <IconFileTextSpark />,
  },
  {
    label: 'Resources',
    href: routes.resources.path,
    icon: <IconFile />,
  },
]
